import { CacaoService } from './../../shared/services/cacao.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { Balance } from 'src/app/shared/models/balances';
import { Dispersion } from 'src/app/shared/models/dispersions';
import { BalancesService } from 'src/app/shared/services/balances.service';
import { DispersionsService } from 'src/app/shared/services/dispersions.service';
import { UtilitiesService } from 'src/app/shared/services/utilities.service';
import * as _ from 'lodash';
import { Level } from '../../shared/enums/level.enum';
import { DxChartComponent } from 'devextreme-angular';

@Component({
  templateUrl: 'home.component.html',
  styleUrls: ['./home.component.scss']
})

export class HomeComponent implements OnInit {
  @ViewChild(DxChartComponent, { static: false }) chart: DxChartComponent
  _subscriptions: Subscription[] = [];
  dispersions: Dispersion[] = [];
  dispersionsCompleted: Dispersion[];
  dispersionsPending: Dispersion[];
  balance: any;
  cdta: any;
  udta: any;
  energySources: any[];
  id_companies_list: any[]=[];
  constructor(
    private utilitiesService: UtilitiesService,
    private dispersionsService: DispersionsService,
    private balancesService: BalancesService,
    private cacaoService: CacaoService

  ) {
    
  }

  async ngOnInit() {
    // this.energySources = [
    //   { value: "ROCM", name: "ROCM" },
    //   { value: "Equipo Desarrollo", name: "Equipo Desarrollo" }
    // ];
    this.energySources = [
      { value: "total", name: "Total Diario" }
    ];
    this.cdta = this.utilitiesService.getCompanyData();
    this.udta = this.utilitiesService.getUserData();
    switch (this.udta.level) {
      case Level.ihunterSuperUser:
      case Level.ihunterAdmin:
      case Level.ihunterReportes:
        this._subscriptions.push(
          await this.dispersionsService.getDispersionsWhereStatusIgualMenor3().subscribe((dispersions: any) => {
            console.log(dispersions);
            this.dispersions = dispersions;
            this.dispersionsCompleted = _.filter(dispersions, ['status', 3]);
            this.dispersionsPending = dispersions.filter(dispersion => dispersion.status <= 2);
          })
        );  
        break;
      case Level.CompanyAdmin:
      case Level.CompanyUser:
      case Level.CompanyReportes:
        this._subscriptions.push(
          await this.dispersionsService.getDispersionsWhereStatusIgualMenor3().subscribe(dispersions => {
            this.dispersions = dispersions.filter(dispersion => dispersion.companyId == this.cdta.id);
            this.dispersionsCompleted = _.filter(this.dispersions, ['status', 3]);
            this.dispersionsPending = this.dispersions.filter(dispersion => dispersion.status <= 2);
          })
        );  
        break;
      case Level.Broker:
        this.udta.companyList.forEach(company => {
          this.id_companies_list.push(company.id.trim());
        });
        this._subscriptions.push(
          await this.dispersionsService.getDispersionsWhereStatusIgualMenor3().subscribe(dispersions => {
            this.dispersions = dispersions.filter(dispersion => this.id_companies_list.includes(dispersion.companyId));
            this.dispersionsCompleted = _.filter(this.dispersions, ['status', 3]);
            this.dispersionsPending = this.dispersions.filter(dispersion => dispersion.status <= 2);
          })
        );
        break;
      default:

      break;
    }

    /// Obtemenos Balance de la compañia
    if (this.udta.level <= 3) {
      // Utilizamos un servicio especial para jalar el balance de la cuenta concentradora de Cacao
      this.balance = {
        balance: 0
      }
      this.balancesService.getIhunterBalance().then(balance => {
        console.log(balance);
        this.balance.balance = balance
      });
      
    } else {
      // Jalamos el balance de la compania en especifico almacenado en Firebase para dicha compania.
      this.balancesService.getCompanyBalance(this.cdta.id).subscribe(balance => {
        // console.log(balance);

        this.balance = balance[0];
        // console.log(this.balance);

      });
    }
    this.chart.instance.refresh();
  }
  customizeText(arg) {
    let date: Date = new Date();
    date.setFullYear(arg.valueText.substring(0,4));
    date.setDate(arg.valueText.substring(6));
    date.setMonth(arg.valueText.substring(4,6)-1);
    return date.toISOString().split('T')[0];
  }
}
